import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import API_URL from '../config';

function SignUp({ onSignUp }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/signup`, {
        email,
        password,
      });

      setVerified(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Sign up failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-primary)' }}>
    <div className="card" style={{ width: '100%', maxWidth: '400px', padding: '36px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28, justifyContent: 'center' }}>
          <svg width="28" height="28" viewBox="0 0 32 32" fill="none" style={{ borderRadius: 8, flexShrink: 0 }}>
            <rect width="32" height="32" rx="8" fill="#3b82f6"/>
            <path d="M6 16c0 0 4-6.5 10-6.5S26 16 26 16s-4 6.5-10 6.5S6 16 6 16z" stroke="white" strokeWidth="1.5" fill="none" strokeLinejoin="round"/>
            <circle cx="16" cy="16" r="2.5" fill="white"/>
          </svg>
          <span style={{ fontWeight: 700, fontSize: 17, color: 'var(--text-primary)' }}>Agent Oversight</span>
        </div>
        <h2 style={{ marginBottom: '20px', fontSize: '20px', color: 'var(--text-primary)' }}>Create your account</h2>

        {verified ? (
          <div>
            <div className="alert success" style={{ marginTop: 8 }}>
              Account created! Check your email to verify your account before logging in.
            </div>
            <p style={{ marginTop: 16, textAlign: 'center', fontSize: '14px' }}>
              Already verified? <Link to="/login">Log in</Link>
            </p>
          </div>
        ) : (
          <>
        {error && <div className="alert error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading} style={{ width: '100%', marginTop: 8 }}>
            {loading ? 'Creating account...' : 'Create account'}
          </button>
        </form>

        <p style={{ marginTop: '20px', textAlign: 'center', fontSize: '14px' }}>
          Already have an account? <Link to="/login">Login</Link>
        </p>
          </>
        )}
      </div>
    </div>
  );
}

export default SignUp;
